import React, { useState, useEffect } from "react";
import { motion, AnimatePresence, useReducedMotion } from "framer-motion";
import { BrandMark } from "@/components/common/BrandMark";

const SplashScreen = ({ onComplete }) => {
  const [exiting, setExiting] = useState(false);
  const reducedMotion = useReducedMotion();

  useEffect(() => {
    // Preserve the existing two-second normal splash; never impose motion on reduced-motion users.
    const exit = setTimeout(() => setExiting(true), reducedMotion ? 200 : 1400);
    const complete = setTimeout(() => onComplete?.(), reducedMotion ? 350 : 2000);
    return () => { clearTimeout(exit); clearTimeout(complete); };
  }, [onComplete, reducedMotion]);

  return (
    <AnimatePresence>
      {!exiting && (
        <motion.div data-testid="splash-screen" initial={{ opacity: 1 }} exit={{ opacity: 0 }}
          transition={{ duration: reducedMotion ? 0.15 : 0.6, ease: "easeInOut" }}
          className="fixed inset-0 z-[10000] flex items-center justify-center px-6"
          style={{ background: "linear-gradient(135deg, #0a0f1a 0%, #101826 55%, #0d1b2e 100%)" }}>
          <h1 data-testid="splash-heading" className="w-full max-w-3xl">
            <BrandMark animated={!reducedMotion} testId="splash-wordmark" style={{ width: "100%" }} />
          </h1>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SplashScreen;